import React from "react";
import { BfButtonBlue } from "../../../Styling/styledForm/styledBlueForm";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const ExcelSheet = (props) => {

    const localeMessages = props.localeMessages;

    const asDateForExcel = (val) => {
        if (!val) return '';
        let splittedDate = val.replace(' ', '-').split('-');
        let ExcelDate = splittedDate[2] + '.' + splittedDate[1] + '.' + splittedDate[0];
        return ExcelDate;
    };
 
    const getFileName = () => `${props.headerState.kreditorName}.xlsx`

    const handleExport = () => {
        const wb = XLSX.utils.book_new();

        const headerRow = [
            props.localeMessages['GHF_invoiceDate'],
            props.localeMessages['GHF_dueDate'],
            props.localeMessages['GHF_debitorId'],
            props.localeMessages['GHF_debitorName'],
            props.localeMessages['GHF_invoiceNumber'],
            props.localeMessages['GHF_invoiceText'],
            props.localeMessages['GHF_invoiceAmount']
        ];
        
        // Må matche rekkefølge til headerRow
        const dataRows = props.data.map(row => [
            asDateForExcel(row.invoiceDate),
            asDateForExcel(row.dueDate),
            row.debitorId,
            row.debitorName,
            row.invoiceNumber,
            row.invoiceText,
            row.invoiceAmount
        ]);

        // Smell header og data sammen
        const exportData = [headerRow, ...dataRows];

        // Convert the JSON data to a worksheet
        const ws = XLSX.utils.json_to_sheet(exportData);

        // Append the worksheet to the workbook with the desired sheet name
        XLSX.utils.book_append_sheet(wb, ws, props.filename || "Sheet1");

        // Write the workbook to a binary array
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

        // Create a Blob from the binary data and trigger a download
        saveAs(new Blob([wbout], { type: "application/octet-stream" }), getFileName());
    };

    return (
        <BfButtonBlue onClick={handleExport}>
            Excel export
        </BfButtonBlue>
    );
}

export default ExcelSheet;
